export const pages = {
	'boltWatchMore': { id: 'boltWatchMore', page: 'home', getter: () => import(/* webpackChunkName: 'boltWatchMore' */ 'components/bolt/home/home') },
	'main': { id: 'main', page: 'main', getter: () => import(/* webpackChunkName: 'main' */ 'components/bolt/main/main') }
};
export const sections = [
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "boltWatchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore' }
];
export const sectionsWithParent = [

];
